import opentelemetry from '@opentelemetry/api';

export const tracingPropagate =
  () =>
  (next) =>
  async (url, { headers, ...opts }) => {
    if (opentelemetry.context.active()) {
      const myHeaders = {};
      const span = opentelemetry.trace.getTracer('reporting-tracer').startSpan(`${opts.method} ${url}`);
      const ctxTelemetry = opentelemetry.trace.setSpan(opentelemetry.context.active(), span);
      opentelemetry.propagation.inject(ctxTelemetry, myHeaders);
      const nextHeaders = { ...headers, ...myHeaders };
      try {
        return await next(url, { ...opts, headers: nextHeaders });
      } finally {
        span.end();
      }
    }
    return next(url, { headers, ...opts });
  };
